module.exports = __webpack_public_path__ + "img/logo-bondi-new.7c12b723.svg";